export enum TransactionType {
    INCOME,
    EXPENSE,
}
